import { R } from '@/Resources.resx';

export const getTimedGreeting = (firstName: string) => {
    const now = new Date();
    const hour = now.getHours();

    if (hour >= 5 && hour < 11) {
        return `${R.TimedGreetingMorning} ${firstName}`;
    } else if (hour >= 17 && hour <= 23) {
        return `${R.TimedGreetingEvening} ${firstName}`;
    } else {
        return `${R.TimedGreetingNormal} ${firstName}`;
    }
};
